import { apiPost, apiGet, apiDelete, apiPut } from './api/api-helpers';

export interface Content {
  _id: string;
  date: string;
  content: string;
  source: string;
  lang: string;
  status: 'P' | 'U' | 'D';
}

export interface ClearAllResponse {
  message: string;
  deletedCount: number;
}

export const contentService = {
  createMultiple: async (contents: Omit<Content, 'status'>[]): Promise<Content[]> => {
    const response = await apiPost<Content[]>('/api/content/multiple', contents);
    return response;
  },
  /**
   * Obtiene todos los contenidos
   * @returns Promise con la lista de contenidos
   */
  getAllContents: async (): Promise<Content[]> => {
    const response = await apiGet<Content[]>('/api/content?status=all&limit=100');
    return response;
  },
  /**
   * Elimina todos los contenidos
   * @returns Promise con el resultado de la operación, incluyendo el número de registros eliminados
   */
  clearAllContents: async (): Promise<ClearAllResponse> => {
    const response = await apiDelete<ClearAllResponse>('/api/content');
    return response;
  },
  /**
   * Despublica un contenido específico
   * @param contentId ID del contenido a despublicar
   * @returns Promise con el contenido actualizado
   */
  unpublishContent: async (contentId: string): Promise<Content> => {
    const response = await apiPut<Content>(`/api/content/unpublish/${contentId}`);
    return response;
  },
  async deleteContent(contentId: string): Promise<void> {
    return apiDelete(`/api/content/${contentId}`);
  },
  // Aquí puedes añadir más métodos según necesites
};
